import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const notificationsRouteRef = createRouteRef();

// No `icon` here — this page is reached via the header bell's "View all
// notifications" link, not a left-sidebar entry (Sidebar.tsx's items are
// curated explicitly, not derived from this).
const notificationsPage = PageBlueprint.make({
  name: 'notifications',
  params: {
    path: '/notifications',
    routeRef: notificationsRouteRef,
    noHeader: true,
    loader: () =>
      import('./pages/NotificationsPage').then(m => <m.NotificationsPage />),
  },
});

export const notificationsPlugin = createFrontendPlugin({
  pluginId: 'notifications',
  extensions: [notificationsPage],
});
